import { FunctionOr, unwrap } from '../../helpers/FunctionOr';
import { produce } from '../helpers';
import { TPContext } from '../types';

export type Recent = {
    text: string;
    url: string;
    description?: string;
    viewName?: string;
};

export type RecentContext = {
    recentHistory?: Recent[];
    readonly setRecentHistory: (history: FunctionOr<Recent[]>) => void;
    readonly pushRecentHistory: (point: Recent) => void;
    readonly clearRecentHistory: () => void;
};

export const recentlyViewsContext: TPContext<RecentContext> = (set, get, api) => {
    return {
        recentHistory: null,
        setRecentHistory(history) {
            set(
                produce(store => {
                    store.recentHistory = unwrap(history, store.recentHistory);
                }),
            );
        },
        pushRecentHistory: point => {
            set(
                produce(store => {
                    const newHistory = store.recentHistory?.filter(({ url }) => url !== point.url) || [];
                    newHistory.unshift(point);
                    if (newHistory.length > 10) {
                        newHistory.length = 10;
                    }
                    store.recentHistory = newHistory;
                }),
            );
        },
        clearRecentHistory: () => get().setRecentHistory(null),
    };
};
